import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { useLocalization } from '~/composables/_next/useLocalization';
import { getProductPrice } from '~/utils/ProductPrice';
import AzLoader from '~/components/_next/atoms/AzLoader.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzRating from '~/components/_next/atoms/AzRating.vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import PriceDiscountLabel from '~/components/Product/ProductPrice/PriceDiscountLabel.vue';
import WishlistButton from '~/components/Product/WishlistButton.vue';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import { useUser } from '~/composables/_next/useUser';
import { useCart } from '~/composables/useCart';
import { useProductPropertiesAttributes } from '~/composables/useProductPropertiesAttributes';
import { useProductVariants } from '~/composables/useProduct/useProductVariants';
import useRightPath from '~/composables/useRightPath';
import { useBooxi } from '~/composables/_next/useBooxi';
import { useWorkshop } from '~/composables/_next/useWorkshop';
import { useWait } from '~/composables/_next/useWait';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { gtmPushEvent, gtmDiscountValue, gtmValue, gtmPriceFormat } from '~/helpers/gtm';
import { klaviyoClientPushEvent } from '~/helpers/tracking/klaviyo';
import { isProductInStock, isAnyVariantSellable, isProductDiscontinued } from '~/utils/ProductAvailability';
import { getMainImage, getCapacity, getProductUsageType, getProductAttrsStringForQueryParams } from '~/helpers/productCardMethods';
import { BUNDLE_LABEL_ATTR_KEY, BUNDLE_LABEL_DEFAULT_LOCALE, BUNDLE_PRODUCTS_ATTR_KEY } from '~/constants/productsConstants';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { ProductAttributes, ProductKeys } from '~/types/ProductEnums';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCardOrganism',
  props: {
    product: null,
    imageWidth: {
      default: 262
    },
    imageHeight: {
      default: 194
    },
    imageLoading: {
      default: 'lazy'
    },
    productIndex: {
      default: 0
    },
    cardLocation: {
      default: null
    },
    isPlp: {
      type: Boolean
    },
    direction: {
      default: 'column'
    }
  },
  setup: function setup(__props) {
    var _attrsBeauty$value, _attrsWellness$value, _user$value;
    var props = __props;
    var _useNuxt2App = useNuxt2App(),
      app = _useNuxt2App.app,
      $trackers = _useNuxt2App.$trackers;
    var _useLocalization = useLocalization(),
      currency = _useLocalization.currency,
      locale = _useLocalization.locale;
    var route = useRoute();
    var router = useRouter();
    var _useBooxi = useBooxi(),
      loadBooxi = _useBooxi.loadBooxi,
      openBooxi = _useBooxi.openBooxi;
    var _useWorkshop = useWorkshop(),
      checkAndAddWorkshopToCart = _useWorkshop.checkAndAddWorkshopToCart;
    var _useProductVariants = useProductVariants(props.product),
      masterVariant = _useProductVariants.masterVariant,
      displayVariant = _useProductVariants.displayVariant;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin;
    var _useRightPath = useRightPath(),
      getProductPath = _useRightPath.getProductPath;
    var _useUiState = useUiState(),
      openBackInStockModal = _useUiState.openBackInStockModal,
      openAddToCartModal = _useUiState.openAddToCartModal;
    var _useProductProperties = useProductPropertiesAttributes(),
      getFinalAttributeString = _useProductProperties.getFinalAttributeString;
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile;
    var _useCart = useCart(),
      addItemById = _useCart.addItemById,
      cart = _useCart.cart;
    var _useWait = useWait(),
      startWaiter = _useWait.startWaiter,
      endWaiter = _useWait.endWaiter,
      isWaiting = _useWait.isWaiting;
    var _useDynamicYield = useDynamicYield(),
      trackDynamicYieldEvent = _useDynamicYield.trackDynamicYieldEvent,
      formatDYprice = _useDynamicYield.formatDYprice;
    var usageType = computed(function () {
      return getProductUsageType(locale, props.product);
    });
    var price = computed(function () {
      return getProductPrice(displayVariant.value);
    });
    var title = computed(function () {
      var _props$product;
      return (_props$product = props.product) === null || _props$product === void 0 ? void 0 : _props$product._name;
    });
    var image = getMainImage(displayVariant.value);
    var hoverImage = computed(function () {
      var _props$product2, _props$product2$image, _props$product2$image2;
      return (_props$product2 = props.product) === null || _props$product2 === void 0 ? void 0 : (_props$product2$image = _props$product2.images) === null || _props$product2$image === void 0 ? void 0 : (_props$product2$image2 = _props$product2$image[0]) === null || _props$product2$image2 === void 0 ? void 0 : _props$product2$image2.url;
    });
    var masterVariantSku = computed(function () {
      var _masterVariant$value$, _masterVariant$value, _displayVariant$value;
      return (_masterVariant$value$ = (_masterVariant$value = masterVariant.value) === null || _masterVariant$value === void 0 ? void 0 : _masterVariant$value.sku) !== null && _masterVariant$value$ !== void 0 ? _masterVariant$value$ : displayVariant === null || displayVariant === void 0 ? void 0 : (_displayVariant$value = displayVariant.value) === null || _displayVariant$value === void 0 ? void 0 : _displayVariant$value.sku;
    });
    var variantCount = computed(function () {
      var _props$product3, _props$product4, _props$product5, _props$product5$_orig, _props$product5$_orig2, _props$product5$_orig3;
      var variants = (_props$product3 = props.product) !== null && _props$product3 !== void 0 && _props$product3.variants ? [props.product].concat(_toConsumableArray((_props$product4 = props.product) === null || _props$product4 === void 0 ? void 0 : _props$product4.variants)) : (_props$product5 = props.product) === null || _props$product5 === void 0 ? void 0 : (_props$product5$_orig = _props$product5._original) === null || _props$product5$_orig === void 0 ? void 0 : (_props$product5$_orig2 = _props$product5$_orig.masterData) === null || _props$product5$_orig2 === void 0 ? void 0 : (_props$product5$_orig3 = _props$product5$_orig2.current) === null || _props$product5$_orig3 === void 0 ? void 0 : _props$product5$_orig3.allVariants;
      var filteredVariants = variants === null || variants === void 0 ? void 0 : variants.filter(function (variant) {
        var _variant$price, _variant$price$value;
        return (variant === null || variant === void 0 ? void 0 : variant.sku) && (variant === null || variant === void 0 ? void 0 : (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : (_variant$price$value = _variant$price.value) === null || _variant$price$value === void 0 ? void 0 : _variant$price$value.centAmount) && !isProductDiscontinued(variant);
      });
      return (filteredVariants === null || filteredVariants === void 0 ? void 0 : filteredVariants.length) || 1;
    });
    var isProductHasVariant = computed(function () {
      var _props$product6, _props$product6$varia, _props$product7, _props$product7$_orig, _props$product7$_orig2, _props$product7$_orig3, _props$product7$_orig4;
      return ((_props$product6 = props.product) === null || _props$product6 === void 0 ? void 0 : (_props$product6$varia = _props$product6.variants) === null || _props$product6$varia === void 0 ? void 0 : _props$product6$varia.length) > 0 || ((_props$product7 = props.product) === null || _props$product7 === void 0 ? void 0 : (_props$product7$_orig = _props$product7._original) === null || _props$product7$_orig === void 0 ? void 0 : (_props$product7$_orig2 = _props$product7$_orig.masterData) === null || _props$product7$_orig2 === void 0 ? void 0 : (_props$product7$_orig3 = _props$product7$_orig2.current) === null || _props$product7$_orig3 === void 0 ? void 0 : (_props$product7$_orig4 = _props$product7$_orig3.allVariants) === null || _props$product7$_orig4 === void 0 ? void 0 : _props$product7$_orig4.length) > 1;
    });
    var isInStock = computed(function () {
      return isProductInStock(props.product) || isAnyVariantSellable(props.product);
    });
    var isBestSeller = computed(function () {
      var _props$product$attrib, _props$product$attrib2;
      return !!((_props$product$attrib = props.product.attributesRaw) !== null && _props$product$attrib !== void 0 && (_props$product$attrib2 = _props$product$attrib.find(function (attribute) {
        return attribute.name === ProductAttributes.bestSeller;
      })) !== null && _props$product$attrib2 !== void 0 && _props$product$attrib2.value);
    });
    var isNew = computed(function () {
      var _props$product$attrib3, _props$product$attrib4;
      return !!((_props$product$attrib3 = props.product.attributesRaw) !== null && _props$product$attrib3 !== void 0 && (_props$product$attrib4 = _props$product$attrib3.find(function (attribute) {
        return attribute.name === ProductAttributes.isNew;
      })) !== null && _props$product$attrib4 !== void 0 && _props$product$attrib4.value);
    });
    var attrsBeauty = computed(function () {
      var _props$product8, _props$product8$attri;
      return (_props$product8 = props.product) === null || _props$product8 === void 0 ? void 0 : (_props$product8$attri = _props$product8.attributesRaw) === null || _props$product8$attri === void 0 ? void 0 : _props$product8$attri.find(function (attribute) {
        return attribute.name === ProductAttributes.beautyProperties;
      });
    });
    var attrsWellness = computed(function () {
      var _props$product9, _props$product9$attri;
      return (_props$product9 = props.product) === null || _props$product9 === void 0 ? void 0 : (_props$product9$attri = _props$product9.attributesRaw) === null || _props$product9$attri === void 0 ? void 0 : _props$product9$attri.find(function (attribute) {
        return attribute.name === ProductAttributes.wellnessProperties;
      });
    });
    var finalAttributesString = getFinalAttributeString((_attrsBeauty$value = attrsBeauty.value) === null || _attrsBeauty$value === void 0 ? void 0 : _attrsBeauty$value.value, (_attrsWellness$value = attrsWellness.value) === null || _attrsWellness$value === void 0 ? void 0 : _attrsWellness$value.value);
    var isBundle = computed(function () {
      var _props$product0, _props$product0$sku;
      return (_props$product0 = props.product) === null || _props$product0 === void 0 ? void 0 : (_props$product0$sku = _props$product0.sku) === null || _props$product0$sku === void 0 ? void 0 : _props$product0$sku.startsWith('bundle');
    });
    var bundleProperties = computed(function () {
      if (isBundle.value) {
        var _displayVariant$value2, _displayVariant$value3;
        return (_displayVariant$value2 = displayVariant.value) === null || _displayVariant$value2 === void 0 ? void 0 : (_displayVariant$value3 = _displayVariant$value2.attributesRaw) === null || _displayVariant$value3 === void 0 ? void 0 : _displayVariant$value3.reduce(function (acc, curr) {
          acc[curr.name] = curr.value;
          return acc;
        }, {});
      }
      return null;
    });
    var bundleLabel = computed(function () {
      if (isBundle.value) {
        var _labelProperty$label, _labelProperty$label2;
        var labelProperty = bundleProperties.value[BUNDLE_LABEL_ATTR_KEY];
        return (labelProperty === null || labelProperty === void 0 ? void 0 : (_labelProperty$label = labelProperty.label) === null || _labelProperty$label === void 0 ? void 0 : _labelProperty$label[locale.toLowerCase()]) || (labelProperty === null || labelProperty === void 0 ? void 0 : (_labelProperty$label2 = labelProperty.label) === null || _labelProperty$label2 === void 0 ? void 0 : _labelProperty$label2[BUNDLE_LABEL_DEFAULT_LOCALE]);
      }
      return null;
    });
    var bundleCapacityUnit = computed(function () {
      if (isBundle.value) {
        var _capacityProperty$lab, _capacityProperty$lab2;
        var capacityProperty = bundleProperties.value[ProductKeys.capacityUnit];
        return (capacityProperty === null || capacityProperty === void 0 ? void 0 : (_capacityProperty$lab = capacityProperty.label) === null || _capacityProperty$lab === void 0 ? void 0 : _capacityProperty$lab[locale.toLowerCase()]) || (capacityProperty === null || capacityProperty === void 0 ? void 0 : (_capacityProperty$lab2 = capacityProperty.label) === null || _capacityProperty$lab2 === void 0 ? void 0 : _capacityProperty$lab2[BUNDLE_LABEL_DEFAULT_LOCALE]);
      }
      return '';
    });
    var bundleCount = computed(function () {
      var _bundleProperties$val;
      return isBundle.value ? (_bundleProperties$val = bundleProperties.value[BUNDLE_PRODUCTS_ATTR_KEY]) === null || _bundleProperties$val === void 0 ? void 0 : _bundleProperties$val.length : 0;
    });
    var capacity = computed(function () {
      return isBundle.value ? " ".concat(bundleCount.value, " ").concat(bundleCapacityUnit.value) : getCapacity(locale, displayVariant.value);
    });
    var scoreRating = computed(function () {
      var _props$product1, _props$product1$_rati;
      return ((_props$product1 = props.product) === null || _props$product1 === void 0 ? void 0 : (_props$product1$_rati = _props$product1._rating) === null || _props$product1$_rati === void 0 ? void 0 : _props$product1$_rati.averageRating) || 0;
    });
    var reviewsCount = computed(function () {
      var _props$product10, _props$product10$_rat;
      return ((_props$product10 = props.product) === null || _props$product10 === void 0 ? void 0 : (_props$product10$_rat = _props$product10._rating) === null || _props$product10$_rat === void 0 ? void 0 : _props$product10$_rat.count) || 0;
    });
    var link = computed(function () {
      var queryString = getProductAttrsStringForQueryParams(displayVariant.value);
      var defaultLink = app.localePath(getProductPath(props.product));
      if (!isProductDiscontinued(masterVariant) || !props.isPlp || !isInStock.value) return defaultLink;
      return defaultLink + queryString;
    });
    var isBookShop = computed(function () {
      if (!Array.isArray(props.product.attributesRaw)) {
        return false;
      }
      var rdvBookshopAttribute = props.product.attributesRaw.find(function (item) {
        return item.name === 'bookshop';
      });
      return !!(rdvBookshopAttribute !== null && rdvBookshopAttribute !== void 0 && rdvBookshopAttribute.value);
    });
    var bookingFilterTagsValue = computed(function () {
      if (props.product) {
        var attribute = props.product.sku;
        return attribute || null;
      }
      return null;
    });
    var _useUser = useUser(),
      user = _useUser.user,
      isAuthenticated = _useUser.isAuthenticated;
    var customerEmail = isAuthenticated.value ? (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.email : '';
    var gtmEcommerceItems = computed(function () {
      var _price$value, _price$value2, _price$value3, _price$value4, _price$value5, _price$value6, _price$value7, _price$value8, _price$value9, _price$value0;
      return {
        value: gtmValue((_price$value = price.value) === null || _price$value === void 0 ? void 0 : _price$value.regular, (_price$value2 = price.value) === null || _price$value2 === void 0 ? void 0 : _price$value2.special),
        value_in_cents: gtmValue((_price$value3 = price.value) === null || _price$value3 === void 0 ? void 0 : _price$value3.regular, (_price$value4 = price.value) === null || _price$value4 === void 0 ? void 0 : _price$value4.special, true),
        items: [{
          item_id: "SKU_".concat(props.product.sku),
          item_sku: props.product.sku,
          item_name: title.value,
          discount: gtmDiscountValue((_price$value5 = price.value) === null || _price$value5 === void 0 ? void 0 : _price$value5.regular, (_price$value6 = price.value) === null || _price$value6 === void 0 ? void 0 : _price$value6.special),
          discount_in_cents: gtmDiscountValue((_price$value7 = price.value) === null || _price$value7 === void 0 ? void 0 : _price$value7.regular, (_price$value8 = price.value) === null || _price$value8 === void 0 ? void 0 : _price$value8.special, true),
          new_product: isNew.value,
          index: Number(props.productIndex) + 1,
          item_location: 'product_card',
          card_location: props.cardLocation,
          price: gtmPriceFormat((_price$value9 = price.value) === null || _price$value9 === void 0 ? void 0 : _price$value9.regular),
          price_in_cents: gtmPriceFormat((_price$value0 = price.value) === null || _price$value0 === void 0 ? void 0 : _price$value0.regular, true),
          currency: currency
        }]
      };
    });

    /**
     * Adds the product to cart.
     */
    function addProductToCart() {
      return _addProductToCart.apply(this, arguments);
    }
    /**
     * Opens the workshop booking modal (i.e. booxi)
     */
    function _addProductToCart() {
      _addProductToCart = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _price$value1, _price$value10, _cart$value, _props$product11, _price$value11, _price$value12, _props$product12, _props$product12$imag, _price$value13, _price$value14, _props$product13, _props$product14, _props$product15, AddedProperties, productWithIndex;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!isProductHasVariant.value && !isInStock.value)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return", openBackInStockModal(props.product));
            case 4:
              if (isProductHasVariant.value) {
                _context.next = 22;
                break;
              }
              startWaiter("add-to-cart-".concat(props.product._id));
              _context.prev = 6;
              _context.next = 9;
              return addItemById({
                product: props.product,
                quantity: 1,
                showConfirmation: !isMobile.value,
                customQuery: {
                  updateCart: 'updateCartCustom'
                }
              });
            case 9:
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](6);
              console.error('Failed to add item to cart', _context.t0);
            case 14:
              _context.prev = 14;
              endWaiter("add-to-cart-".concat(props.product._id));
              return _context.finish(14);
            case 17:
              trackDynamicYieldEvent({
                name: 'Add to Cart',
                properties: {
                  dyType: 'add-to-cart-v1',
                  value: formatDYprice(price.value.regular, price.value.special),
                  currency: 'EUR',
                  productId: props.product.sku,
                  quantity: 1,
                  cart: [{
                    productId: props.product.sku,
                    quantity: 1,
                    itemPrice: formatDYprice(price.value.regular, price.value.special)
                  }]
                }
              });
              $trackers.gtm.trackAddToCart({
                title: title.value,
                sku: props.product.sku,
                priceRegular: (_price$value1 = price.value) === null || _price$value1 === void 0 ? void 0 : _price$value1.regular,
                priceSpecial: (_price$value10 = price.value) === null || _price$value10 === void 0 ? void 0 : _price$value10.special,
                quantity: 1,
                isNewProduct: isNew.value,
                itemLocation: 'product_card',
                index: Number(props.productIndex) + 1,
                currency: currency,
                cartId: ((_cart$value = cart.value) === null || _cart$value === void 0 ? void 0 : _cart$value.id) || '',
                ctId: (_props$product11 = props.product) === null || _props$product11 === void 0 ? void 0 : _props$product11._id,
                pageUrl: route.fullPath
              });
              if (customerEmail) {
                AddedProperties = {
                  AddedToCartValue: gtmValue((_price$value11 = price.value) === null || _price$value11 === void 0 ? void 0 : _price$value11.regular, (_price$value12 = price.value) === null || _price$value12 === void 0 ? void 0 : _price$value12.special),
                  AddedItemCategories: 'product',
                  AddedItemCurrency: currency,
                  AddedItemImageURL: (_props$product12 = props.product) === null || _props$product12 === void 0 ? void 0 : (_props$product12$imag = _props$product12.images[0]) === null || _props$product12$imag === void 0 ? void 0 : _props$product12$imag.url,
                  AddedItemPrice: (_price$value13 = price.value) === null || _price$value13 === void 0 ? void 0 : _price$value13.regular,
                  AddedItemPriceDiscount: ((_price$value14 = price.value) === null || _price$value14 === void 0 ? void 0 : _price$value14.special) || '',
                  AddedItemProductID: (_props$product13 = props.product) === null || _props$product13 === void 0 ? void 0 : _props$product13._id,
                  AddedItemProductName: (_props$product14 = props.product) === null || _props$product14 === void 0 ? void 0 : _props$product14._name,
                  AddedItemProductSKU: (_props$product15 = props.product) === null || _props$product15 === void 0 ? void 0 : _props$product15.sku,
                  AddedItemProductUrl: link.value,
                  AddedItemQuantity: 1,
                  AddedItemURL: route.fullPath
                };
                klaviyoClientPushEvent(customerEmail, locale, AddedProperties, 'Added to cart');
              }
              _context.next = 24;
              break;
            case 22:
              productWithIndex = _objectSpread(_objectSpread({}, props.product), {}, {
                productIndex: props.productIndex
              });
              openAddToCartModal(productWithIndex);
            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[6, 11, 14, 17]]);
      }));
      return _addProductToCart.apply(this, arguments);
    }
    function bookNow() {
      return _bookNow.apply(this, arguments);
    }
    /**
     * Handles the different "add to cart" features
     */
    function _bookNow() {
      _bookNow = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var serviceTags;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              serviceTags = bookingFilterTagsValue.value;
              _context3.next = 3;
              return loadBooxi();
            case 3:
              openBooxi({
                shopId: null,
                serviceTags: serviceTags,
                bookingFlow: 'locations',
                onClose: function onClose(booxiData) {
                  if ((booxiData === null || booxiData === void 0 ? void 0 : booxiData.bookNowStatus) === 'Booked') {
                    doActionOrLogin({
                      nextRoutePath: app.localePath({
                        name: 'checkout-workshop'
                      }),
                      previousRoutePath: route.path,
                      action: function () {
                        var _action = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                          return regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) switch (_context2.prev = _context2.next) {
                              case 0:
                                _context2.next = 2;
                                return checkAndAddWorkshopToCart(booxiData);
                              case 2:
                              case "end":
                                return _context2.stop();
                            }
                          }, _callee2);
                        }));
                        function action() {
                          return _action.apply(this, arguments);
                        }
                        return action;
                      }()
                    });
                  }
                }
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _bookNow.apply(this, arguments);
    }
    function handleAddToCart() {
      isBookShop.value ? bookNow() : addProductToCart();
    }

    /**
     * Redirects to the product page
     * and its "reviews" section
     */
    function goToProductReviews() {
      router.push(app.localePath({
        path: getProductPath(props.product),
        hash: 'rating-reviews'
      }));
    }

    /**
     * Handles the action of navigating to the product page
     * and triggering the GTM event.
     */
    function goToProductPageAndGtmEvent() {
      gtmPushEvent('select_item', {
        event_category: 'ecommerce',
        event_action: 'click',
        event_label: title.value,
        event_name: 'select_item',
        page_url: route.fullPath,
        new_product: isNew.value,
        ecommerce: gtmEcommerceItems.value
      });
      router.push(link.value);
    }
    return {
      __sfc: true,
      props: props,
      app: app,
      $trackers: $trackers,
      currency: currency,
      locale: locale,
      route: route,
      router: router,
      loadBooxi: loadBooxi,
      openBooxi: openBooxi,
      checkAndAddWorkshopToCart: checkAndAddWorkshopToCart,
      masterVariant: masterVariant,
      displayVariant: displayVariant,
      doActionOrLogin: doActionOrLogin,
      getProductPath: getProductPath,
      openBackInStockModal: openBackInStockModal,
      openAddToCartModal: openAddToCartModal,
      getFinalAttributeString: getFinalAttributeString,
      isMobile: isMobile,
      addItemById: addItemById,
      cart: cart,
      startWaiter: startWaiter,
      endWaiter: endWaiter,
      isWaiting: isWaiting,
      trackDynamicYieldEvent: trackDynamicYieldEvent,
      formatDYprice: formatDYprice,
      usageType: usageType,
      price: price,
      title: title,
      image: image,
      hoverImage: hoverImage,
      masterVariantSku: masterVariantSku,
      variantCount: variantCount,
      isProductHasVariant: isProductHasVariant,
      isInStock: isInStock,
      isBestSeller: isBestSeller,
      isNew: isNew,
      attrsBeauty: attrsBeauty,
      attrsWellness: attrsWellness,
      finalAttributesString: finalAttributesString,
      isBundle: isBundle,
      bundleProperties: bundleProperties,
      bundleLabel: bundleLabel,
      bundleCapacityUnit: bundleCapacityUnit,
      bundleCount: bundleCount,
      capacity: capacity,
      scoreRating: scoreRating,
      reviewsCount: reviewsCount,
      link: link,
      isBookShop: isBookShop,
      bookingFilterTagsValue: bookingFilterTagsValue,
      user: user,
      isAuthenticated: isAuthenticated,
      customerEmail: customerEmail,
      gtmEcommerceItems: gtmEcommerceItems,
      addProductToCart: addProductToCart,
      bookNow: bookNow,
      handleAddToCart: handleAddToCart,
      goToProductReviews: goToProductReviews,
      goToProductPageAndGtmEvent: goToProductPageAndGtmEvent,
      AzLoader: AzLoader,
      AzIcon: AzIcon,
      AzButton: AzButton,
      AzRating: AzRating,
      AzImg: AzImg,
      PriceDiscountLabel: PriceDiscountLabel,
      WishlistButton: WishlistButton,
      PriceDisplay: PriceDisplay
    };
  }
});